import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67f9f87d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  slot: "content",
  class: "app-content"
}

import { computed, ref } from 'vue'
import { RouterView } from 'vue-router'

import AppLayoutHeaderNew from './AppLayoutHeader/AppLayoutHeaderNew.vue'
import AppLayoutSidebarNew from './AppLayoutSidebarMenu/AppLayoutSidebarNew.vue'
import AppLayoutMobileSidebar from './AppLayoutSidebarMenu/AppLayoutMobileSidebar.vue'
import AppLayoutFooter from './AppLayoutFooter.vue'
import { useDevice } from './useDevice'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutMainNew',
  setup(__props) {

const { device } = useDevice()

const isMobile = computed(() => device.value === 'mobile')

const showMobileMenu = ref<boolean>(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-page-layout", null, [
    (!isMobile.value)
      ? (_openBlock(), _createBlock(AppLayoutSidebarNew, {
          key: 0,
          slot: "menu"
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(AppLayoutHeaderNew, {
      slot: "navbar",
      onMobileMenuClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu.value = true))
    }),
    (isMobile.value && showMobileMenu.value)
      ? (_openBlock(), _createBlock(AppLayoutMobileSidebar, {
          key: 1,
          slot: "menu",
          class: "dsf-hidden-tablet dsf-hidden-desktop mobile-menu",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showMobileMenu.value = false))
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_unref(RouterView), { class: "dsf-theme-default" }),
      _createVNode(AppLayoutFooter, {
        class: "footer",
        "is-mobile-layout": isMobile.value
      }, null, 8 /* PROPS */, ["is-mobile-layout"])
    ])
  ]))
}
}

})